import { formValueSelector } from 'redux-form'

import { REDUCER_NAME, FORM_NAME } from './constants'

export const physicalFormSelector = formValueSelector(FORM_NAME)
export const juridicalFormSelector = formValueSelector(FORM_NAME)

export const getFields = (state) => state[REDUCER_NAME].fields
export const getSelects = (state) => state[REDUCER_NAME].selects
export const getCityList = (state) => state[REDUCER_NAME].cityList

export const getDynamicFields = (state) => state[REDUCER_NAME].dynamicFields

export const isFetching = (state) => state[REDUCER_NAME].fetching

/**
 * @ignore
 *
 * Get child options according to master's value
 * (Master select's change causes child selects change)
 *
 * @param {Object} store
 * @param {String} formSelector
 * @param {Object} MasterChild
 * @property {String} master - name of master select
 * @property {String} child - name of child select
 *
 * @returns {Object}
 *
 */
export const getMasterChildOptions = (state, formSelector, masterChilds) => {
  const res = masterChilds.reduce((result, { master, child, masterAlias }) => {
    const masterSelectID = formSelector(state, master)

    const options = state[REDUCER_NAME].selects[child].filter(
      (option) => option[masterAlias || master] === parseInt(masterSelectID, 10) || option.ID === 1,
    )

    return {
      ...result,
      [child]: options,
    }
  }, {})

  return res
}
